// extracted by mini-css-extract-plugin
export default {"icon":"creator_icon__tarb2"};